<template>
  <v-row
    justify="center"
    class="text-center"
  >
    <v-col
      cols="12"
      class="subtitle-1"
    >
      <v-btn
        text
        color="primary"
        :disabled="count === 0"
        @click="open"
      >
        <v-icon
          left
          small
        >
          mdi-bank
        </v-icon>
        <span class="text-decoration-underline"> Accounts: {{ count }}</span>
      </v-btn>
    </v-col>
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="400px"
    >
      <v-card>
        <v-card-title class="headline pa-3">
          <v-text-field
            v-model.trim="search"
            append-icon="mdi-magnify"
            label="Search accounts"
            single-line
            clearable
            outlined
            hide-details
            dense
          />
        </v-card-title>
        <v-divider />
        <v-card-text class="px-0">
          <v-list class="py-0">
            <div
              v-for="acc in filteredAccounts"
              :key="`accounts--${acc.id}`"
            >
              <v-list-item @click="goTo(acc.id)">
                <v-list-item-title>
                  {{ acc.name }}
                </v-list-item-title> 
                <v-list-item-action>
                  <v-icon
                    color="error"
                    @click.stop="unLinkCorporate(acc.id, acc.name)"
                  >
                    mdi-close
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider />
            </div>
            <div
              v-if="!filteredAccounts.length && search"
              class="py-3"
              align="center"
            >
              No records found. reset the search
            </div>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            id="corporate_account_close"
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "CorporateAccounts",
  props: {
    corporateId: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      accounts: [],
      search: ""
    };
  },
  computed: {
    filteredAccounts() {
      if (this.search) {
        const searchText = this.search.toUpperCase();
        return this.accounts.filter((acc) => {
          return acc.name.toUpperCase().indexOf(searchText) > -1;
        });
      }
      return this.accounts;
    }
  },
  methods: {
    close() {
      this.dialog = false;
    },
    open() {
      this.dialog = true;
      this.$http
        .get(`${this.ADMIN_API_URL}/corporates/${this.corporateId}/accounts`)
        .then(function (data) {
          this.accounts = data.body;
        });
    },
    unLinkCorporate(accountId, accountName) {
      this.$root.$confirm
        .open("Confirm", `Are you sure you want to unlink ${accountName}?`, {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.req = {
            accountId: accountId,
            corporateId: null
          };
          this.$http.put(`${this.ADMIN_API_URL}/linkCorporate`, this.req).then(
            function (data) {
              this.open();
              this.$store.commit("showSnackbar", {
                timeout: 3000,
                message: data.body.message
              });
            },
            function (failure) {
              this.handleFailure(failure);
            }
          );
        });
    },
    goTo(accId) {
      this.$router.push({
        name: "accountInfo",
        params: {
          accountId: accId
        }
      });
    }
  }
};
</script>